// Treenin volyymi- ja sarjalaskenta (osio 7.1).
// Puhtaita funktioita → yksikkötestattavia (osio 11, testi #1).
// Prisman Decimal-paino tulee API:sta merkkijonona, joten Number() aina.

interface VolumeSet {
  weight: number | string | null | undefined;
  reps: number | null | undefined;
}
interface VolumeExercise {
  sets: VolumeSet[];
}

/**
 * Kokonaisvolyymi = Σ(paino × toistot) niistä sarjoista, joissa paino ei ole
 * null. Painoton sarja ohitetaan (esim. Garmin-tuonnit ilman painoa).
 */
export function computeWorkoutVolume(exercises: VolumeExercise[]): number {
  let total = 0;
  for (const ex of exercises) {
    for (const s of ex.sets) {
      if (s.weight === null || s.weight === undefined || s.weight === '') continue;
      const w = Number(s.weight);
      if (!Number.isFinite(w)) continue;
      const r = Number(s.reps ?? 0);
      if (!Number.isFinite(r)) continue;
      total += w * r;
    }
  }
  return Math.round(total * 100) / 100;
}

/** Sarjojen kokonaismäärä treenissä. */
export function computeSetCount(exercises: { sets: unknown[] }[]): number {
  return exercises.reduce((n, ex) => n + ex.sets.length, 0);
}

/**
 * Muotoile kilogrammat suomalaisella tuhaterottimella (välilyönti), esim.
 * 4250 → "4 250". Ei riipu Intl-lokaalista → deterministinen testeissä.
 */
export function formatVolume(kg: number): string {
  const n = Math.round(kg);
  const sign = n < 0 ? '-' : '';
  const digits = Math.abs(n).toString();
  const withSep = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return sign + withSep;
}
